import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PORTALS, RequireAuth } from '@client/auth';
import { setSignedInUser } from '@client/redux/loggedInUser/loggedInUserActions';
import { selectLoggedInUserRoles } from '@client/redux/loggedInUser/loggedInUserReducer';
import { checkAuthorized } from './restrictUtils';

export const withRestrictions = ({
  permissions = [],
  shouldBeLoggedIn = false,
  isAdvertiserRoute = false,
}) => {
  // Routes that need a signed-in user are guarded by their Portal's Auth Gate.
  let portalRequired = null;

  if (shouldBeLoggedIn) {
    portalRequired = isAdvertiserRoute ? PORTALS.ADVERTISER : PORTALS.ADMIN;
  }

  return (WrappedComponent, FallbackComponent) => {
    class Restrict extends PureComponent {
      renderFallback(props) {
        return FallbackComponent ? <FallbackComponent {...props} /> : null;
      }

      static loadData(store) {
        if (
          WrappedComponent &&
          typeof WrappedComponent.loadData === 'function'
        ) {
          WrappedComponent.loadData(store);
        }
      }

      // Which Portal's Auth Gate guards this route, if any. The server reads it
      // to know a route's data can only be loaded in the browser.
      static portalRequired = portalRequired;

      syncSignedInUser = (profile) => {
        this.props.dispatch(setSignedInUser(profile));
      };

      renderPage() {
        const { userPermissions, ...otherProps } = this.props;

        return checkAuthorized(permissions, userPermissions) ? (
          <WrappedComponent {...otherProps} />
        ) : (
          this.renderFallback({ ...otherProps })
        );
      }

      render() {
        if (!portalRequired) {
          return this.renderPage();
        }

        return (
          <RequireAuth
            portal={portalRequired}
            onProfileLoaded={this.syncSignedInUser}
          >
            {this.renderPage()}
          </RequireAuth>
        );
      }
    }

    Restrict.propTypes = {
      dispatch: PropTypes.func,
      userPermissions: PropTypes.array,
    };

    function mapStateToProps(state) {
      return {
        userPermissions: selectLoggedInUserRoles(state),
      };
    }

    return connect(mapStateToProps)(Restrict);
  };
};

export default (restrictions) => (WrapperComponent, FallbackComponent) => {
  return withRestrictions(restrictions)(WrapperComponent, FallbackComponent);
};
